import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const bsaOutputSlice = createSlice({
  name: "BSAOutputReducer",
  initialState: { pageNo: 1, pageSize: 10 },
  reducers: {
    setBSAOutputPageNo: (state, action: PayloadAction<number>) => {
      state.pageNo = action.payload;
    },
    setBSAOutputPageSize: (state, action: PayloadAction<number>) => {
      state.pageSize = action.payload;
    },
  },
});

export const { setBSAOutputPageNo, setBSAOutputPageSize } = bsaOutputSlice.actions;
export default bsaOutputSlice.reducer;
